<script setup lang="ts">
import Icon from '~/components/common/Icon.vue'
import IconArrowNarrowRight from '~/assets/icons/arrow-narrow-right.svg'
import { getLibNameByMarket } from '~/src/utils/all-reports'

const props = defineProps({
  priceName: {
    type: String,
    required: true,
  },
  iconName: {
    type: String,
    required: true,
  },
})

const MARKET_NAME = getLibNameByMarket(props.priceName)
const PRICE_LABEL = `${MARKET_NAME} Prices`
</script>

<template>
  <div
    class="group flex rounded lg:rounded-lg md:w-[220px] transition-colors duration-300 cursor-pointer"
  >
    <div class="px-1.5 py-6">
      <Icon class="w-5 h-5 lg:w-7 lg:h-7" :name="`sidebar/${iconName}`" />
    </div>
    <div
      class="bg-white group-hover:bg-p-100 w-full px-1 md:px-3 flex flex-col justify-center rounded-r lg:rounded-r-xl transition-colors duration-300"
    >
      <div
        class="flex text-sm md:text-xs font-semibold items-center md:justify-normal justify-between gap-x-1 md:hidden group-hover:flex md:gap-x-2"
      >
        <span class="hidden lg:inline-block">View Prices</span>
        <span class="lg:hidden">{{ PRICE_LABEL }}</span>
        <div>
          <IconArrowNarrowRight class="w-4 h-4 shrink-0" />
        </div>
      </div>
      <div
        class="text-h7 lg:text-h5 group-hover:text-h7 font-semibold hidden md:block"
      >
        <span class="group-hover:inline-block hidden">
          {{ MARKET_NAME }}
        </span>
        <span class="group-hover:hidden">{{ PRICE_LABEL }}</span>
      </div>
    </div>
  </div>
</template>
